module.exports = __webpack_public_path__ + "static/media/insights-dark.6bb54b4b.png";